import React from 'react'
import { Link } from 'react-router-dom';
import { ReactComponent as WaveSquare } from './../../../assets/wave-square.svg';
import { Card } from './card';

import styles from './dashboardShortcutCard.module.css';

export const DashboardShortcutCard = ({subtitle = '', icon = <></>, to = ''}) => {
    return <Card className={styles.Card}>
        <Link className={styles.Interact} to={to}>
            <div className={styles.Icon}>
                <div className='icon text-color light-stroke'>
                    {icon}
                </div>
            </div>
            <hr/>
            <div className={styles.Link}>{subtitle}</div>
        </Link>
        <div className={styles.Wave}>
            <WaveSquare />
        </div>
    </Card>
}